import { defineMessages } from 'react-intl';

export const commentsi18n = defineMessages({
	resolvedByInfoText: {
		id: 'comments-util.resolved.by.info.text',
		defaultMessage: 'Resolved by {username} {friendlyDate}',
		description:
			'Info text on the resolved comments telling who resolved the comment and when, for example: Resolved by John Doe May 3, 2024',
	},
	reopenedByTooltipTextCommentsPanel: {
		id: 'comments-util.reopened.by.tooltip.text.comments.panel',
		defaultMessage: 'Added {createdAtNonLocalized}, reopened by {username}',
		description:
			'Tooltip text shown when hovering over the reopened info text, providing context as to which user resolved the comment',
	},
	createdTimestamp: {
		id: 'comments-util.timestamp.created',
		defaultMessage: 'created {timestamp}',
		description: 'Timestamp string for created comments, used in aria labels and tooltips',
	},
	resolvedDateInfoText: {
		id: 'comments-util.resolved.date.info.text',
		defaultMessage: 'Resolved {friendlyDate}',
		description:
			'Info text on the resolved comments telling when the comment was resolved, for example: Resolved May 3, 2024',
	},
	reopenedDateInfoText: {
		id: 'comments-util.reopened.date.info.text',
		defaultMessage: 'Reopened {friendlyDate}',
		description:
			'Info text on the reopened comments telling when the comment was reopened, for example: Reopened May 3, 2024',
	},
	generalCommentTooltip: {
		id: 'comments-util.view.tooltip.general.comment',
		defaultMessage: 'General comment',
		description: 'Tooltip for general comment icon in the comment panel',
	},
	anonymous: {
		id: 'comments-util.display.name.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text used in place of a missing username',
	},
	editedBy: {
		id: 'comments-util.edited.by',
		defaultMessage: 'Edited by {username} {at}',
		description:
			'This text is shown in the Edited label tooltip to display the user who edited the comment and at what time the comment was edited',
	},
	edited: {
		id: 'comments-util.edited',
		defaultMessage: 'Edited',
		description:
			'This text is shown as a label next to the comment date to indicate that a comment has been edited',
	},
	resolvedByTooltipTextCommentsPanel: {
		id: 'comments-util.resolved.by.tooltip.text.comments.panel',
		defaultMessage: 'By {username}',
		description:
			'Tooltip text shown when hovering over the resolved info text, providing context as to which user resolved the comment',
	},
});
